import { baseApi } from "./base";
import type { DashboardStats } from "../types";

const dashboardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** GET admin/dashboard — aggregate platform statistics */
    getDashboardStats: builder.query<DashboardStats, void>({
      query: () => "admin/dashboard/stats",
      providesTags: [{ type: "Dashboard", id: "STATS" }],
    }),
  }),
});

export const { useGetDashboardStatsQuery } = dashboardApi;
